import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import Rating from 'react-rating';
import { Checkbox } from 'semantic-ui-react';

import { RESPONSE_STATUS } from '../../utils/constants';
import './ProductReview.css';

import Api from '../../utils/api';

export default class ProductReview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rating: 0,
			feedback: {}
		};

		this.updateRating = this.updateRating.bind(this);
		this.toggleFeedback = this.toggleFeedback.bind(this);
		this.submitReview = this.submitReview.bind(this);
	}

	updateRating(value) {
		this.setState({ rating: value });
	}

	toggleFeedback(checked, optionId) {
		let feedback = this.state.feedback;
		if (checked) {
			feedback[optionId] = true;
		} else {
			delete feedback[optionId];
		}
		this.setState({ feedback: feedback });
	}

	submitReview() {
		const rating = this.state.rating;
		const feedback = this.state.feedback;
		const feedbackOptions = Object.keys(feedback);
		if (rating === 0) {
			alert("Please rate the product.");
			return;
		}
		if (feedbackOptions.length === 0) {
			alert("Please check at least one feedback for the product.");
			return;
		}
		const userId = localStorage.getItem("user_id");
		const productId = this.props.product.id;
        const promise1 = new Promise((resolve, reject) => {
			fetch("/api/product-ratings", {
	            method: 'POST',
	            headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'x-auth-token': Api.auth_tokenManager()
	            },
				body: JSON.stringify({
					userId: userId,
					productId: productId,
					rating: rating
				})
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject();
	            }
	        });
		});
		const promise2 = new Promise((resolve, reject) => {
			const url = "/api/product-feedbacks?user-id=" + userId + "&product-id=" + productId + "&feedback=" + feedbackOptions;
			fetch(url, {
	            method: 'POST',
	            headers: {
					'x-auth-token': Api.auth_tokenManager()
	            }
	        }).then(response => {
	            if (response.status === RESPONSE_STATUS.OK) {
	                resolve();
	            } else {
	                reject();
	            }
	        });
		});
		Promise.all([promise1, promise2]).then(res => {
			this.props.closeModal();
		}).catch(err => {
			alert("There is a problem to save the review. Please try again.");
		});
	}

	render() {
		const product = this.props.product;
		const feedbackOptions = product.productFeedbackOptionDTOList.map(option =>
			<div key={ option.id } className="feedback-option">
				<div className="text">{ option.option }</div>
				<Checkbox checked={ option.id in this.state.feedback } onChange={(event, data) => this.toggleFeedback(data.checked, option.id)} />
			</div>
		);
		return (
			<div className="product-review">
				<div className="left">
					<img alt={ product.name } src={ product.coverImageSource } />
					<div className="name">{ product.name }</div>
					<div className="price">{ "$" + product.price }</div>
				</div>
				<div className="right">
					<div className="question">How did you like your product?</div>
					<div className="rating">
						<Rating emptySymbol={<ReactSVG path="/images/common/star.svg" wrapperClassName="svg-wrapper" style={{ width: '33px', height: '33px' }}/>}
					 		fullSymbol={<ReactSVG path="/images/common/star.svg" wrapperClassName="svg-wrapper selected" style={{ width: '33px', height: '33px' }}/>}
							onChange={ this.updateRating } initialRating={ this.props.rating ? this.props.rating : this.state.rating } />
					</div>
					<div className="question">The product makes my skin:</div>
					<div className="feedback">
						<div className="grid">
							{ feedbackOptions }
						</div>
					</div>
					<div className="submit">
						<button onClick={ this.submitReview }>Submit</button>
					</div>
				</div>
			</div>
		);
	}
}

ProductReview.propTypes = {
	product: PropTypes.object.isRequired,
	closeModal: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/skinprofile/ProductReview.js